<template>
  <div>
    <div :class="{'mb-24': user.photo}">
      <div class="mb-6 flex justify-start max-w-3xl">
        <h1 class="font-bold text-3xl">
          <template v-if="$page.props.can['see users module']">
            <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('users')">Użytkownicy</inertia-link>  
          </template>
          <template v-else>
            <span class="text-shtax-400">Użytkownicy</span>  
          </template>
          <span class="text-shtax-400 font-medium">/</span>
          {{ form.first_name }} {{ form.last_name }}
        </h1>
      </div>
      <trashed-message v-if="user.deleted_at" class="mb-6" @restore="restore">
        Użytkownik jest oznaczony jako usunięty.
      </trashed-message>
    </div>

    <div class="bg-white rounded-md shadow w-full xl:w-1/2">
      <form @submit.prevent="update">
        <div class="p-8 md:-mr-6 -mb-8 flex flex-wrap">
          <div class="w-full relative">
            <img v-if="user.photo" class="block w-40 h-40 rounded-full shadow-xl absolute -top-28" style="left: 50%;-webkit-transform: translateX(-55%);transform: translateX(-55%)" :src="user.photo" />
          </div>

          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pr-6 pb-8 w-full lg:w-1/2" :class="{'pt-12': user.photo}" label="Imię" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pr-6 pb-8 w-full lg:w-1/2" :class="{'lg:pt-12': user.photo}" label="Nazwisko" />
          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-1/2" label="Adres e-mail" />
          <text-input v-model="form.password" :error="form.errors.password" class="pr-6 pb-8 w-full lg:w-1/2" type="password" autocomplete="new-password" label="Hasło" />
          <multiselect-input v-model="form.role" :error="form.errors.role" class="pr-6 pb-8 w-full lg:w-full" label="Rola" :options="options" v-if="$page.props.can['see admin module']" />

          <file-input v-model="form.photo" :error="form.errors.photo" class="pr-6 pb-8 w-full" type="file" accept="image/*" label="Zdjęcie/Avatar" />

        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!user.deleted_at && $page.props.can['delete users']" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Usuń użytkownika</button>
          <loading-button :loading="form.processing" class="btn-shtax ml-auto" type="submit">Aktualizuj</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import FileInput from '@/ShtaxComponents/FileInput'
import TrashedMessage from '@/Shared/TrashedMessage'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'
import Swal from 'sweetalert2'

export default {
  metaInfo() {
    return {
      title: `${this.form.first_name} ${this.form.last_name}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    MultiselectInput,
    FileInput
  },
  layout: Layout,
  props: {
    user: Object,
    roles: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'PUT',
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        password: null,
        role: this.user.roles.map(role => role.name),
        photo: null
      }),
      options: this.roles
    }
  },
  methods: {
    update() {
      this.form.post('/users/'+ this.user.id, {
        onSuccess: () => this.form.reset('password', 'photo'),
      })
    },
    destroy() {
      Swal.fire({
        title: 'Jesteś pewny że chcesz usunąć tego użytkownika?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Tak, usuń!',
        cancelButtonText: 'Nie'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(this.route('users.destroy', this.user.id))
        }
      })
    },
    restore() {
      Swal.fire({
        title: 'Jesteś pewien że chcesz przywrócić tego użytkownika?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Tak, przywróć!',
        cancelButtonText: 'Nie'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.put(this.route('users.restore', this.user.id))
        }
      })
    },
  },
}
</script>
